<script>
import { useUserStore, useStockStore, useAppUpdateStore, useAppSystemConfigStore } from "@/stores/index.js"
import { AppCheckUpdate } from "@/api/app.js"
export default {
	onLaunch: function () {
		console.log('App Launch')
		const stockStore = useStockStore();
		const userStore = useUserStore();
		const appUpdateStore = useAppUpdateStore();
		const appSystemConfigStore = useAppSystemConfigStore();

		// #ifdef APP-PLUS
		appUpdateStore.onCheckForUpdate();
		// #endif

		// #ifdef H5
		// appSystemConfigStore.onGetSystemBasic().catch(() => {});
		// #endif

		// 获取市场列表
		stockStore.getMarketList()

		uni.onLocaleChange(() => {
			stockStore.getMarketList();
		})

		if (userStore.token) {
			userStore.onGetUserInfo();
		}
	},
	onShow: function () {
		console.log('App Show')
	},
	onHide: function () {
		console.log('App Hide')
	}
}
</script>

<style lang="scss">
/* #ifndef APP-NVUE */
/*每个页面公共css */
@import "@/styles/index.scss";
/* #endif */
</style>
